// import React from 'react';
// import { Link } from 'react-router-dom';
// import services from '../../data/services';

// const ServiceSidebar = ({ currentServiceId }) => {
//   return (
//     <div className="bg-white shadow-md rounded-lg overflow-hidden">
//       <div className="bg-blue-600 py-4 px-6">
//         <h3 className="text-lg font-bold text-white">Our Services</h3>
//       </div>
      
//       <div className="divide-y divide-gray-200">
//         {services.map((service) => (
//           <div key={service.id}>
//             <Link
//               to={service.route}
//               className={`block px-6 py-4 hover:bg-blue-50 transition-colors ${
//                 service.id === currentServiceId ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'
//               }`}
//             >
//               {service.title}
//             </Link>
            
//             {service.id === currentServiceId && service.subServices && (
//               <div className="pl-8 pb-2 bg-gray-50">
//                 {service.subServices.map((subService) => (
//                   <Link
//                     key={subService.id}
//                     to={`/services/${service.id}/${subService.id}`}
//                     className="block px-4 py-2 text-sm hover:text-blue-600 transition-colors"
//                   >
//                     {subService.title}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
      
//       <div className="bg-blue-700 text-white p-6 mt-6">
//         <h4 className="text-lg font-bold mb-3">Need Help?</h4>
//         <p className="text-sm mb-4">Contact our support team for assistance with our services</p>
//         <Link
//           to="/contact-us"
//           className="block bg-white text-blue-700 text-center py-2 px-4 rounded hover:bg-blue-50 transition-colors"
//         >
//           Contact Us
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default ServiceSidebar;

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import services from '../../data/services';

const ServiceSidebar = ({ currentServiceId }) => {
  const [expandedService, setExpandedService] = useState(null);

  // Expand current service automatically if it has subservices
  useEffect(() => {
    const currentService = services.find(s => s.id === currentServiceId);
    if (currentService && currentService.subServices?.length > 0) {
      setExpandedService(currentServiceId);
    } else {
      setExpandedService(null);
    }
  }, [currentServiceId]);

  const handleToggle = (serviceId) => {
    setExpandedService(expandedService === serviceId ? null : serviceId);
  };

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="bg-blue-600 py-4 px-6">
        <h3 className="text-lg font-bold text-white">Our Services</h3>
      </div>

      <div className="divide-y divide-gray-200">
        {services.map((service) => (
          <div key={service.id}>
            {/* Main service clickable area */}
            <div
              className={`flex justify-between items-center px-6 py-4 hover:bg-blue-50 transition-colors ${
                service.id === currentServiceId ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700'
              }`}
            >
              <Link
                to={service.route}
                className="flex-1"
                onClick={(e) => {
                  if (service.subServices?.length > 0) {
                    // e.preventDefault(); // prevent navigation if subservices exist
                    handleToggle(service.id);
                  }
                }}
              >
                {service.title}
              </Link>

              {service.subServices?.length > 0 && (
                <button
                  onClick={() => handleToggle(service.id)}
                  className="ml-2 text-gray-500 hover:text-blue-600 focus:outline-none"
                >
                  {expandedService === service.id ? '▾' : '▸'}
                </button>
              )}
            </div>

            {/* Subservices */}
            {expandedService === service.id && service.subServices?.length > 0 && (
              <div className="pl-8 pb-2 bg-gray-50">
                {service.subServices.map((subService) => (
                  <Link
                    key={subService.id}
                    to={`/services/${service.id}/${subService.id}`}
                    className="block px-4 py-2 text-sm hover:text-blue-600 transition-colors"
                  >
                    {subService.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="bg-blue-700 text-white p-6 mt-6">
        <h4 className="text-lg font-bold mb-3">Need Help?</h4>
        <p className="text-sm mb-4">Contact our support team for assistance with our services</p>
        <Link
          to="/contact-us"
          className="block bg-white text-blue-700 text-center py-2 px-4 rounded hover:bg-blue-50 transition-colors"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default ServiceSidebar;
